// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export const enumValues = <T extends {}, V = T[keyof T]>(e: T) => Object.values(e) as [V, ...V[]];

export enum AdPlatform {
    Line = 'line',
    Meta = 'meta',
}

export type Statistics = {
    campaignId: string;
    campaignName: string;
    adGroupId: string;
    adGroupName: string;
    adId: string;
    adName: string;
    currency: string;
    cost: number;
    impressions: number;
    clicks: number;
};
